import axios from 'axios';
import { Message } from 'element-ui'
import qs from 'qs'
// var baseurl = "http://172.16.6.3:4009/CM-API/api"; //秉兴本地
// var baseurl = "http://hailiang.58vip.cn/CM-API/api" //测试服
var baseurl = "https://education.vastdata.com.cn/CM-API/api" //正式服
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseurl+url,
        headers: {
            'content-type':'application/x-www-form-urlencoded; charset=UTF-8',
            token: localStorage.getItem('token')
        },
        data: qs.stringify(params),
        traditional: true,
    }).then(res => {

        if(res.data.code == 0 || res.data.code == 200 ){
            return res.data;
        }else{
            Message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
                offset:100
            });
            if(res.data.code == 401){
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/login/login'
                }, 1500);
                return
            }
        }
      }) .catch(err => {
        Message({
            showClose: true,
            message: '服务器请求失败！',
            type: 'error',
            offset:100
        });
      })
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: baseurl+url,
        headers: {
           'content-type':'application/x-www-form-urlencoded; charset=UTF-8',
            token: localStorage.getItem('token')
        },
        data: params,
        traditional: false,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        if(res.data.code == 0){
            return res.data;
        }else{
            Message({
                message: res.data.msg,
                type: 'success'
            })
        }
      }) .catch(err => {
        Message({
            showClose: true,
            message: '服务器请求失败111！',
            type: 'error'
        });
      }).then(res => res.data);
};


export {
    loginreq,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js